/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AdmissionStatus } from './AdmissionStatus';
import {
    AdmissionStatusFromJSON,
    AdmissionStatusFromJSONTyped,
    AdmissionStatusToJSON,
} from './AdmissionStatus';
import type { AnalysisResult } from './AnalysisResult';
import {
    AnalysisResultFromJSON,
    AnalysisResultFromJSONTyped,
    AnalysisResultToJSON,
} from './AnalysisResult';
import type { Document } from './Document';
import {
    DocumentFromJSON,
    DocumentFromJSONTyped,
    DocumentToJSON,
} from './Document';
import type { ExternalEhrPatient } from './ExternalEhrPatient';
import {
    ExternalEhrPatientFromJSON,
    ExternalEhrPatientFromJSONTyped,
    ExternalEhrPatientToJSON,
} from './ExternalEhrPatient';
import type { Facility } from './Facility';
import {
    FacilityFromJSON,
    FacilityFromJSONTyped,
    FacilityToJSON,
} from './Facility';
import type { LeadAdmissionFlagsInner } from './LeadAdmissionFlagsInner';
import {
    LeadAdmissionFlagsInnerFromJSON,
    LeadAdmissionFlagsInnerFromJSONTyped,
    LeadAdmissionFlagsInnerToJSON,
} from './LeadAdmissionFlagsInner';
import type { LeadAdmissionStatusInfo } from './LeadAdmissionStatusInfo';
import {
    LeadAdmissionStatusInfoFromJSON,
    LeadAdmissionStatusInfoFromJSONTyped,
    LeadAdmissionStatusInfoToJSON,
} from './LeadAdmissionStatusInfo';
import type { LeadClaimedByFacility } from './LeadClaimedByFacility';
import {
    LeadClaimedByFacilityFromJSON,
    LeadClaimedByFacilityFromJSONTyped,
    LeadClaimedByFacilityToJSON,
} from './LeadClaimedByFacility';
import type { LeadScreenerAdditionalDocumentsInner } from './LeadScreenerAdditionalDocumentsInner';
import {
    LeadScreenerAdditionalDocumentsInnerFromJSON,
    LeadScreenerAdditionalDocumentsInnerFromJSONTyped,
    LeadScreenerAdditionalDocumentsInnerToJSON,
} from './LeadScreenerAdditionalDocumentsInner';
import type { LeadScreenerLeadInfo } from './LeadScreenerLeadInfo';
import {
    LeadScreenerLeadInfoFromJSON,
    LeadScreenerLeadInfoFromJSONTyped,
    LeadScreenerLeadInfoToJSON,
} from './LeadScreenerLeadInfo';
import type { LeadScreenerLeadTagsInner } from './LeadScreenerLeadTagsInner';
import {
    LeadScreenerLeadTagsInnerFromJSON,
    LeadScreenerLeadTagsInnerFromJSONTyped,
    LeadScreenerLeadTagsInnerToJSON,
} from './LeadScreenerLeadTagsInner';
import type { LeadStatus } from './LeadStatus';
import {
    LeadStatusFromJSON,
    LeadStatusFromJSONTyped,
    LeadStatusToJSON,
} from './LeadStatus';
import type { LeadTimData } from './LeadTimData';
import {
    LeadTimDataFromJSON,
    LeadTimDataFromJSONTyped,
    LeadTimDataToJSON,
} from './LeadTimData';
import type { LeadWaitlist } from './LeadWaitlist';
import {
    LeadWaitlistFromJSON,
    LeadWaitlistFromJSONTyped,
    LeadWaitlistToJSON,
} from './LeadWaitlist';
import type { ScreenerDocumentError } from './ScreenerDocumentError';
import {
    ScreenerDocumentErrorFromJSON,
    ScreenerDocumentErrorFromJSONTyped,
    ScreenerDocumentErrorToJSON,
} from './ScreenerDocumentError';
import type { ScreenerInsurance } from './ScreenerInsurance';
import {
    ScreenerInsuranceFromJSON,
    ScreenerInsuranceFromJSONTyped,
    ScreenerInsuranceToJSON,
} from './ScreenerInsurance';
import type { ScreenerSpecialCriteria } from './ScreenerSpecialCriteria';
import {
    ScreenerSpecialCriteriaFromJSON,
    ScreenerSpecialCriteriaFromJSONTyped,
    ScreenerSpecialCriteriaToJSON,
} from './ScreenerSpecialCriteria';
import type { ScreenerSuggestion } from './ScreenerSuggestion';
import {
    ScreenerSuggestionFromJSON,
    ScreenerSuggestionFromJSONTyped,
    ScreenerSuggestionToJSON,
} from './ScreenerSuggestion';
import type { SourceContact } from './SourceContact';
import {
    SourceContactFromJSON,
    SourceContactFromJSONTyped,
    SourceContactToJSON,
} from './SourceContact';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface Lead
 */
export interface Lead {
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    source_id: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    source_name?: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    facility_id: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    first_name: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    last_name: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    lead_received_date: string;
    /**
     * 
     * @type {ScreenerSuggestion}
     * @memberof Lead
     */
    screener_suggestion?: ScreenerSuggestion;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    status_id?: string;
    /**
     * 
     * @type {LeadStatus}
     * @memberof Lead
     */
    status?: LeadStatus;
    /**
     * 
     * @type {Array<Document>}
     * @memberof Lead
     */
    documents?: Array<Document>;
    /**
     * 
     * @type {Array<AnalysisResult>}
     * @memberof Lead
     */
    analysis_results?: Array<AnalysisResult>;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    report_s3_access_url?: string;
    /**
     * 
     * @type {Array<ScreenerSpecialCriteria>}
     * @memberof Lead
     */
    special_criteria?: Array<ScreenerSpecialCriteria>;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    pcc_pending_patient_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    external_ehr_patient_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    comments_summary?: string;
    /**
     * 
     * @type {User}
     * @memberof Lead
     */
    pcc_push_by_user?: User;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    pcc_push_date?: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    connector?: LeadConnectorEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    connector_no_sync?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    connector_referral_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    connector_created_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    gender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    dob?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    medicaid_number?: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    medicare_number?: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    ssn?: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    source_contact_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    original_move_in_date?: string;
    /**
     * 
     * @type {SourceContact}
     * @memberof Lead
     */
    source_contact?: SourceContact;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    is_visual_references_ready?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    exclude_from_duplicate_check?: boolean;
    /**
     * 
     * @type {LeadClaimedByFacility}
     * @memberof Lead
     */
    claimed_by_facility?: LeadClaimedByFacility;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    is_cancelled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    duplicate_group_id?: string;
    /**
     * 
     * @type {Facility}
     * @memberof Lead
     */
    facility?: Facility;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    created_at?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    is_large_document_ai_used?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    medications_extraction_complete?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    is_medication_analysis_completed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    are_all_documents_analyzed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    has_insufficient_document_context?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    s_offender_records_stored?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    s_offender_check_failed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    medicare_estimates_status?: LeadMedicareEstimatesStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    medicare_estimates_visual_refs_ready?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    source_comments?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    source_comments_received_at?: string;
    /**
     * 
     * @type {string}
     * @memberof Lead
     */
    declined_reason?: string;
    /**
     * 
     * @type {ExternalEhrPatient}
     * @memberof Lead
     */
    external_ehr_patient?: ExternalEhrPatient;
    /**
     * 
     * @type {AdmissionStatus}
     * @memberof Lead
     */
    admission_status?: AdmissionStatus;
    /**
     * 
     * @type {LeadAdmissionStatusInfo}
     * @memberof Lead
     */
    admission_status_info?: LeadAdmissionStatusInfo;
    /**
     * 
     * @type {LeadAdmissionStatusInfo}
     * @memberof Lead
     */
    previous_admission_status_info?: LeadAdmissionStatusInfo;
    /**
     * 
     * @type {Array<ScreenerInsurance>}
     * @memberof Lead
     */
    insurances?: Array<ScreenerInsurance>;
    /**
     * 
     * @type {LeadScreenerLeadInfo}
     * @memberof Lead
     */
    screener_lead_info?: LeadScreenerLeadInfo;
    /**
     * 
     * @type {Array<LeadScreenerLeadTagsInner>}
     * @memberof Lead
     */
    screener_lead_tags?: Array<LeadScreenerLeadTagsInner>;
    /**
     * 
     * @type {LeadTimData}
     * @memberof Lead
     */
    tim_data?: LeadTimData;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    has_no_epic_ehr_access?: boolean;
    /**
     * 
     * @type {Array<LeadAdmissionFlagsInner>}
     * @memberof Lead
     */
    admission_flags?: Array<LeadAdmissionFlagsInner>;
    /**
     * 
     * @type {LeadWaitlist}
     * @memberof Lead
     */
    waitlist?: LeadWaitlist;
    /**
     * 
     * @type {Array<ScreenerDocumentError>}
     * @memberof Lead
     */
    document_errors?: Array<ScreenerDocumentError>;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    has_new_hospital_messages?: boolean;
    /**
     * 
     * @type {Array<LeadScreenerAdditionalDocumentsInner>}
     * @memberof Lead
     */
    screener_additional_documents?: Array<LeadScreenerAdditionalDocumentsInner>;
    /**
     * 
     * @type {boolean}
     * @memberof Lead
     */
    has_previous_stay_in_facility?: boolean;
    /**
     * 
     * @type {User}
     * @memberof Lead
     */
    prev_stay_set_by_user?: User;
}


/**
 * @export
 */
export const LeadConnectorEnum = {
    Aida: 'Aida',
    Aidin: 'Aidin',
    Ensocare: 'Ensocare',
    EnsocareVa: 'Ensocare VA',
    EpicCareLink: 'EpicCare Link',
    EpicCareLinkAlbanyMed: 'EpicCare Link Albany Med',
    EpicCareLinkAllinaHealth: 'EpicCare Link Allina Health',
    EpicCareLinkAsante: 'EpicCare Link Asante',
    EpicCareLinkAspirusHealth: 'EpicCare Link Aspirus Health',
    EpicCareLinkBaptistHealth: 'EpicCare Link Baptist Health',
    EpicCareLinkBenefisHealthSystem: 'EpicCare Link Benefis Health System',
    EpicCareLinkBaylorScottWhiteHealth: 'EpicCare Link Baylor Scott & White Health',
    EpicCareLinkBonSecoursMercyHealth: 'EpicCare Link Bon Secours Mercy Health',
    EpicCareLinkBostonMedicalCenter: 'EpicCare Link Boston Medical Center',
    EpicCareLinkBronsonHealthcare: 'EpicCare Link Bronson Healthcare',
    EpicCareLinkBryanHealth: 'EpicCare Link Bryan Health',
    EpicCareLinkBsaHospital: 'EpicCare Link BSA Hospital',
    EpicCareLinkCapeCodHealthcare: 'EpicCare Link Cape Cod Healthcare',
    EpicCareLinkCaroMont: 'EpicCare Link CaroMont',
    EpicCareLinkCentraCare: 'EpicCare Link CentraCare',
    EpicCareLinkChristusHealth: 'EpicCare Link CHRISTUS Health',
    EpicCareLinkCovenantHealthCare: 'EpicCare Link Covenant HealthCare',
    EpicCareLinkDeaconess: 'EpicCare Link Deaconess',
    EpicCareLinkDenverHealth: 'EpicCare Link Denver Health',
    EpicCareLinkDukeHealth: 'EpicCare Link Duke Health',
    EpicCareLinkEcuHealth: 'EpicCare Link ECU Health',
    EpicCareLinkElCaminoHealth: 'EpicCare Link El Camino Health',
    EpicCareLinkEnloeHealth: 'EpicCare Link Enloe Health',
    EpicCareLinkFmolhsCareConnect: 'EpicCare Link FMOLHS CareConnect',
    EpicCareLinkParkview: 'EpicCare Link Parkview',
    EpicCareLinkGenesisHealthcareSystem: 'EpicCare Link Genesis Healthcare System',
    EpicCareLinkHartfordHealthCare: 'EpicCare Link Hartford HealthCare',
    EpicCareLinkHealthPartners: 'EpicCare Link HealthPartners',
    EpicCareLinkHealtheConnection: 'EpicCare Link HealtheConnection',
    EpicCareLinkHennepinCountyMedicalCenter: 'EpicCare Link Hennepin County Medical Center',
    EpicCareLinkHillcrestHealthCareSystem: 'EpicCare Link Hillcrest HealthCare System',
    EpicCareLinkHospitalSistersHealthSystem: 'EpicCare Link Hospital Sisters Health System',
    EpicCareLinkHurleyMedicalCenter: 'EpicCare Link Hurley Medical Center',
    EpicCareLinkIowaHealthCare: 'EpicCare Link Iowa Health Care',
    EpicCareLinkIntegrisHealth: 'EpicCare Link Integris Health',
    EpicCareLinkKaiserPermanente: 'EpicCare Link Kaiser Permanente',
    EpicCareLinkKingsDaughtersHealthSystem: 'EpicCare Link King\'s Daughters Health System',
    EpicCareLinkLegacyHealthyPlanet: 'EpicCare Link Legacy Healthy Planet',
    EpicCareLinkMHealthFairview: 'EpicCare Link M Health Fairview',
    EpicCareLinkMainLineHealth: 'EpicCare Link Main Line Health',
    EpicCareLinkMayoClinic: 'EpicCare Link Mayo Clinic',
    EpicCareLinkMercy: 'EpicCare Link Mercy',
    EpicCareLinkMethodistHospitals: 'EpicCare Link Methodist Hospitals',
    EpicCareLinkMiddlesexHealth: 'EpicCare Link Middlesex Health',
    EpicCareLinkMyMichiganHealth: 'EpicCare Link MyMichigan Health',
    EpicCareLinkNortonHealthcare: 'EpicCare Link Norton Healthcare',
    EpicCareLinkNorthMemorialHealth: 'EpicCare Link North Memorial Health',
    EpicCareLinkOhioHealth: 'EpicCare Link OhioHealth',
    EpicCareLinkOklahomaHeartHospital: 'EpicCare Link Oklahoma Heart Hospital',
    EpicCareLinkOsfHealthCare: 'EpicCare Link OSF HealthCare',
    EpicCareLinkOwensboroHealth: 'EpicCare Link Owensboro Health',
    EpicCareLinkPiedmont: 'EpicCare Link Piedmont',
    EpicCareLinkProvidence: 'EpicCare Link Providence',
    EpicCareLinkSaintFrancis: 'EpicCare Link Saint Francis',
    EpicCareLinkShannonHealth: 'EpicCare Link Shannon Health',
    EpicCareLinkStElizabethHealthcare: 'EpicCare Link St. Elizabeth Healthcare',
    EpicCareLinkSsmHealth: 'EpicCare Link SSM Health',
    EpicCareLinkTexasHealth: 'EpicCare Link Texas Health',
    EpicCareLinkTheQueensHealthSystem: 'EpicCare Link The Queen\'s Health System',
    EpicCareLinkThedaCare: 'EpicCare Link ThedaCare',
    EpicCareLinkTriHealth: 'EpicCare Link TriHealth',
    EpicCareLinkTrinityHealth: 'EpicCare Link Trinity Health',
    EpicCareLinkUcHealth: 'EpicCare Link UCHealth',
    EpicCareLinkUncHealth: 'EpicCare Link UNC Health',
    EpicCareLinkUConnHealth: 'EpicCare Link UConn Health',
    EpicCareLinkUnityPointHealth: 'EpicCare Link UnityPoint Health',
    EpicCareLinkUniversityOfCincinnati: 'EpicCare Link University of Cincinnati',
    EpicCareLinkUniversityOfKansas: 'EpicCare Link University of Kansas',
    EpicCareLinkUniversityOfMarylandMedicalSystem: 'EpicCare Link University of Maryland Medical System',
    EpicCareLinkUniversityOfUtah: 'EpicCare Link University of Utah',
    EpicCareLinkUpmcPinnacle: 'EpicCare Link UPMC Pinnacle',
    EpicCareLinkSouthShoreHealth: 'EpicCare Link South Shore Health',
    EpicCareLinkStLukes: 'EpicCare Link St. Luke\'s',
    EpicCareLinkPremierHealth: 'EpicCare Link Premier Health',
    EpicCareLinkUtHealthEastTexas: 'EpicCare Link UT Health East Texas',
    EpicCareLinkUtSouthwesternMedicalCenter: 'EpicCare Link UT Southwestern Medical Center',
    EpicCareLinkVitruvianHealth: 'EpicCare Link Vitruvian Health',
    EpicCareLinkWellstar: 'EpicCare Link Wellstar',
    EpicCareLinkKetteringHealth: 'EpicCare Link Kettering Health',
    EpicCareLinkOlmstedMedicalCenter: 'EpicCare Link Olmsted Medical Center',
    EpicCareLinkFranciscanHealth: 'EpicCare Link Franciscan Health',
    EpicCareLinkMohawkValleyHealthSystem: 'EpicCare Link Mohawk Valley Health System',
    Fax: 'Fax',
    ManualUpload: 'Manual Upload',
    ManualCopy: 'Manual Copy',
    WellSkyIntake: 'WellSky Intake',
    WellSkyIntakeCarePortQuickCase: 'WellSky Intake CarePort QuickCase',
    WellSkyCarePortReferralIntake: 'WellSky CarePort Referral Intake',
    WellSkyReferralManagement: 'WellSky Referral Management',
    WellSkyReferralManagementWebReferral: 'WellSky Referral Management Web Referral',
    FourNext: 'Four Next'
} as const;
export type LeadConnectorEnum = typeof LeadConnectorEnum[keyof typeof LeadConnectorEnum];

/**
 * @export
 */
export const LeadMedicareEstimatesStatusEnum = {
    NotActive: 'not_active',
    NotEnoughData: 'not_enough_data',
    InProgress: 'in_progress',
    Completed: 'completed',
    Error: 'error',
    Disabled: 'disabled',
    Scheduled: 'scheduled'
} as const;
export type LeadMedicareEstimatesStatusEnum = typeof LeadMedicareEstimatesStatusEnum[keyof typeof LeadMedicareEstimatesStatusEnum];


/**
 * Check if a given object implements the Lead interface.
 */
export function instanceOfLead(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "source_id" in value;
    isInstance = isInstance && "facility_id" in value;
    isInstance = isInstance && "first_name" in value;
    isInstance = isInstance && "last_name" in value;
    isInstance = isInstance && "lead_received_date" in value;

    return isInstance;
}

export function LeadFromJSON(json: any): Lead {
    return LeadFromJSONTyped(json, false);
}

export function LeadFromJSONTyped(json: any, ignoreDiscriminator: boolean): Lead {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'source_id': json['source_id'],
        'source_name': !exists(json, 'source_name') ? undefined : json['source_name'],
        'facility_id': json['facility_id'],
        'first_name': json['first_name'],
        'last_name': json['last_name'],
        'lead_received_date': json['lead_received_date'],
        'screener_suggestion': !exists(json, 'screener_suggestion') ? undefined : ScreenerSuggestionFromJSON(json['screener_suggestion']),
        'status_id': !exists(json, 'status_id') ? undefined : json['status_id'],
        'status': !exists(json, 'status') ? undefined : LeadStatusFromJSON(json['status']),
        'documents': !exists(json, 'documents') ? undefined : ((json['documents'] as Array<any>).map(DocumentFromJSON)),
        'analysis_results': !exists(json, 'analysis_results') ? undefined : ((json['analysis_results'] as Array<any>).map(AnalysisResultFromJSON)),
        'report_s3_access_url': !exists(json, 'report_s3_access_url') ? undefined : json['report_s3_access_url'],
        'special_criteria': !exists(json, 'special_criteria') ? undefined : ((json['special_criteria'] as Array<any>).map(ScreenerSpecialCriteriaFromJSON)),
        'pcc_pending_patient_id': !exists(json, 'pcc_pending_patient_id') ? undefined : json['pcc_pending_patient_id'],
        'external_ehr_patient_id': !exists(json, 'external_ehr_patient_id') ? undefined : json['external_ehr_patient_id'],
        'comments_summary': !exists(json, 'comments_summary') ? undefined : json['comments_summary'],
        'pcc_push_by_user': !exists(json, 'pcc_push_by_user') ? undefined : UserFromJSON(json['pcc_push_by_user']),
        'pcc_push_date': !exists(json, 'pcc_push_date') ? undefined : json['pcc_push_date'],
        'connector': !exists(json, 'connector') ? undefined : json['connector'],
        'connector_no_sync': !exists(json, 'connector_no_sync') ? undefined : json['connector_no_sync'],
        'connector_referral_id': !exists(json, 'connector_referral_id') ? undefined : json['connector_referral_id'],
        'connector_created_at': !exists(json, 'connector_created_at') ? undefined : json['connector_created_at'],
        'gender': !exists(json, 'gender') ? undefined : json['gender'],
        'dob': !exists(json, 'dob') ? undefined : json['dob'],
        'medicaid_number': !exists(json, 'medicaid_number') ? undefined : json['medicaid_number'],
        'medicare_number': !exists(json, 'medicare_number') ? undefined : json['medicare_number'],
        'ssn': !exists(json, 'ssn') ? undefined : json['ssn'],
        'source_contact_id': !exists(json, 'source_contact_id') ? undefined : json['source_contact_id'],
        'original_move_in_date': !exists(json, 'original_move_in_date') ? undefined : json['original_move_in_date'],
        'source_contact': !exists(json, 'source_contact') ? undefined : SourceContactFromJSON(json['source_contact']),
        'is_visual_references_ready': !exists(json, 'is_visual_references_ready') ? undefined : json['is_visual_references_ready'],
        'exclude_from_duplicate_check': !exists(json, 'exclude_from_duplicate_check') ? undefined : json['exclude_from_duplicate_check'],
        'claimed_by_facility': !exists(json, 'claimed_by_facility') ? undefined : LeadClaimedByFacilityFromJSON(json['claimed_by_facility']),
        'is_cancelled': !exists(json, 'is_cancelled') ? undefined : json['is_cancelled'],
        'duplicate_group_id': !exists(json, 'duplicate_group_id') ? undefined : json['duplicate_group_id'],
        'facility': !exists(json, 'facility') ? undefined : FacilityFromJSON(json['facility']),
        'created_at': !exists(json, 'created_at') ? undefined : json['created_at'],
        'is_large_document_ai_used': !exists(json, 'is_large_document_ai_used') ? undefined : json['is_large_document_ai_used'],
        'medications_extraction_complete': !exists(json, 'medications_extraction_complete') ? undefined : json['medications_extraction_complete'],
        'is_medication_analysis_completed': !exists(json, 'is_medication_analysis_completed') ? undefined : json['is_medication_analysis_completed'],
        'are_all_documents_analyzed': !exists(json, 'are_all_documents_analyzed') ? undefined : json['are_all_documents_analyzed'],
        'has_insufficient_document_context': !exists(json, 'has_insufficient_document_context') ? undefined : json['has_insufficient_document_context'],
        's_offender_records_stored': !exists(json, 's_offender_records_stored') ? undefined : json['s_offender_records_stored'],
        's_offender_check_failed': !exists(json, 's_offender_check_failed') ? undefined : json['s_offender_check_failed'],
        'medicare_estimates_status': !exists(json, 'medicare_estimates_status') ? undefined : json['medicare_estimates_status'],
        'medicare_estimates_visual_refs_ready': !exists(json, 'medicare_estimates_visual_refs_ready') ? undefined : json['medicare_estimates_visual_refs_ready'],
        'source_comments': !exists(json, 'source_comments') ? undefined : json['source_comments'],
        'source_comments_received_at': !exists(json, 'source_comments_received_at') ? undefined : json['source_comments_received_at'],
        'declined_reason': !exists(json, 'declined_reason') ? undefined : json['declined_reason'],
        'external_ehr_patient': !exists(json, 'external_ehr_patient') ? undefined : ExternalEhrPatientFromJSON(json['external_ehr_patient']),
        'admission_status': !exists(json, 'admission_status') ? undefined : AdmissionStatusFromJSON(json['admission_status']),
        'admission_status_info': !exists(json, 'admission_status_info') ? undefined : LeadAdmissionStatusInfoFromJSON(json['admission_status_info']),
        'previous_admission_status_info': !exists(json, 'previous_admission_status_info') ? undefined : LeadAdmissionStatusInfoFromJSON(json['previous_admission_status_info']),
        'insurances': !exists(json, 'insurances') ? undefined : ((json['insurances'] as Array<any>).map(ScreenerInsuranceFromJSON)),
        'screener_lead_info': !exists(json, 'screener_lead_info') ? undefined : LeadScreenerLeadInfoFromJSON(json['screener_lead_info']),
        'screener_lead_tags': !exists(json, 'screener_lead_tags') ? undefined : ((json['screener_lead_tags'] as Array<any>).map(LeadScreenerLeadTagsInnerFromJSON)),
        'tim_data': !exists(json, 'tim_data') ? undefined : LeadTimDataFromJSON(json['tim_data']),
        'has_no_epic_ehr_access': !exists(json, 'has_no_epic_ehr_access') ? undefined : json['has_no_epic_ehr_access'],
        'admission_flags': !exists(json, 'admission_flags') ? undefined : ((json['admission_flags'] as Array<any>).map(LeadAdmissionFlagsInnerFromJSON)),
        'waitlist': !exists(json, 'waitlist') ? undefined : LeadWaitlistFromJSON(json['waitlist']),
        'document_errors': !exists(json, 'document_errors') ? undefined : ((json['document_errors'] as Array<any>).map(ScreenerDocumentErrorFromJSON)),
        'has_new_hospital_messages': !exists(json, 'has_new_hospital_messages') ? undefined : json['has_new_hospital_messages'],
        'screener_additional_documents': !exists(json, 'screener_additional_documents') ? undefined : ((json['screener_additional_documents'] as Array<any>).map(LeadScreenerAdditionalDocumentsInnerFromJSON)),
        'has_previous_stay_in_facility': !exists(json, 'has_previous_stay_in_facility') ? undefined : json['has_previous_stay_in_facility'],
        'prev_stay_set_by_user': !exists(json, 'prev_stay_set_by_user') ? undefined : UserFromJSON(json['prev_stay_set_by_user']),
    };
}

export function LeadToJSON(value?: Lead | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'source_id': value.source_id,
        'source_name': value.source_name,
        'facility_id': value.facility_id,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'lead_received_date': value.lead_received_date,
        'screener_suggestion': ScreenerSuggestionToJSON(value.screener_suggestion),
        'status_id': value.status_id,
        'status': LeadStatusToJSON(value.status),
        'documents': value.documents === undefined ? undefined : ((value.documents as Array<any>).map(DocumentToJSON)),
        'analysis_results': value.analysis_results === undefined ? undefined : ((value.analysis_results as Array<any>).map(AnalysisResultToJSON)),
        'report_s3_access_url': value.report_s3_access_url,
        'special_criteria': value.special_criteria === undefined ? undefined : ((value.special_criteria as Array<any>).map(ScreenerSpecialCriteriaToJSON)),
        'pcc_pending_patient_id': value.pcc_pending_patient_id,
        'external_ehr_patient_id': value.external_ehr_patient_id,
        'comments_summary': value.comments_summary,
        'pcc_push_by_user': UserToJSON(value.pcc_push_by_user),
        'pcc_push_date': value.pcc_push_date,
        'connector': value.connector,
        'connector_no_sync': value.connector_no_sync,
        'connector_referral_id': value.connector_referral_id,
        'connector_created_at': value.connector_created_at,
        'gender': value.gender,
        'dob': value.dob,
        'medicaid_number': value.medicaid_number,
        'medicare_number': value.medicare_number,
        'ssn': value.ssn,
        'source_contact_id': value.source_contact_id,
        'original_move_in_date': value.original_move_in_date,
        'source_contact': SourceContactToJSON(value.source_contact),
        'is_visual_references_ready': value.is_visual_references_ready,
        'exclude_from_duplicate_check': value.exclude_from_duplicate_check,
        'claimed_by_facility': LeadClaimedByFacilityToJSON(value.claimed_by_facility),
        'is_cancelled': value.is_cancelled,
        'duplicate_group_id': value.duplicate_group_id,
        'facility': FacilityToJSON(value.facility),
        'created_at': value.created_at,
        'is_large_document_ai_used': value.is_large_document_ai_used,
        'medications_extraction_complete': value.medications_extraction_complete,
        'is_medication_analysis_completed': value.is_medication_analysis_completed,
        'are_all_documents_analyzed': value.are_all_documents_analyzed,
        'has_insufficient_document_context': value.has_insufficient_document_context,
        's_offender_records_stored': value.s_offender_records_stored,
        's_offender_check_failed': value.s_offender_check_failed,
        'medicare_estimates_status': value.medicare_estimates_status,
        'medicare_estimates_visual_refs_ready': value.medicare_estimates_visual_refs_ready,
        'source_comments': value.source_comments,
        'source_comments_received_at': value.source_comments_received_at,
        'declined_reason': value.declined_reason,
        'external_ehr_patient': ExternalEhrPatientToJSON(value.external_ehr_patient),
        'admission_status': AdmissionStatusToJSON(value.admission_status),
        'admission_status_info': LeadAdmissionStatusInfoToJSON(value.admission_status_info),
        'previous_admission_status_info': LeadAdmissionStatusInfoToJSON(value.previous_admission_status_info),
        'insurances': value.insurances === undefined ? undefined : ((value.insurances as Array<any>).map(ScreenerInsuranceToJSON)),
        'screener_lead_info': LeadScreenerLeadInfoToJSON(value.screener_lead_info),
        'screener_lead_tags': value.screener_lead_tags === undefined ? undefined : ((value.screener_lead_tags as Array<any>).map(LeadScreenerLeadTagsInnerToJSON)),
        'tim_data': LeadTimDataToJSON(value.tim_data),
        'has_no_epic_ehr_access': value.has_no_epic_ehr_access,
        'admission_flags': value.admission_flags === undefined ? undefined : ((value.admission_flags as Array<any>).map(LeadAdmissionFlagsInnerToJSON)),
        'waitlist': LeadWaitlistToJSON(value.waitlist),
        'document_errors': value.document_errors === undefined ? undefined : ((value.document_errors as Array<any>).map(ScreenerDocumentErrorToJSON)),
        'has_new_hospital_messages': value.has_new_hospital_messages,
        'screener_additional_documents': value.screener_additional_documents === undefined ? undefined : ((value.screener_additional_documents as Array<any>).map(LeadScreenerAdditionalDocumentsInnerToJSON)),
        'has_previous_stay_in_facility': value.has_previous_stay_in_facility,
        'prev_stay_set_by_user': UserToJSON(value.prev_stay_set_by_user),
    };
}

